import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { toastMessage } from "../../../shared/components/common/toast";
import { confirmAlert } from "react-confirm-alert";
import { setUser } from "../../../shared/redux/reducers/userSlice";
import { AcceptOffer } from "../../../shared/services/bookService";
import { Reject, EditOffer } from "../../../shared/services/offerService";
import SingleBookDetailsCard from "../singleBookDetails";
import DigiBook from "../../../abis/DigiBook.json";
import { getWeb3 } from "../../../shared/util/getWeb3";
import AlertModal from "../../../shared/components/modal/alert";
import axios from "axios";

import "./style.css";

function OfferCard({ item, reload }) {
  const user = useSelector((state) => state.root.user);
  const [isAlert, setIsAlert] = useState(false);
  const [message, setMsg] = useState("");
  const [title, setTitle] = useState("");
  const openAlertModal = () => {
    if (
      item?.offeringBook?.library?.price === item?.offeredBook?.library?.price
    ) {
      setTitle("Equal Price");
      setMsg(
        "The price is same for both books. So, only books will be swapped. Do you wish to proceed?"
      );
    } else if (
      item?.offeringBook?.library?.price >= item?.offeredBook?.library?.price
    ) {
      let ammountToBePaid =
        parseInt(item?.offeringBook?.library?.price) -
        parseInt(item?.offeredBook?.library?.price);
      setTitle("Cheaper");
      setMsg(
        `Your book is cheaper than the one you want to swap with. You will have to pay $${ammountToBePaid} along with book. Do you wish to proceed?`
      );
    } else if (
      item?.offeringBook?.library?.price <= item?.offeredBook?.library?.price
    ) {
      let ammountToBePaid =
        parseInt(item?.offeredBook?.library?.price) -
        parseInt(item?.offeringBook?.library?.price);
      setTitle("Expensive");
      setMsg(
        `Your book is expensive than the one you want to swap with. If you proceed, the other party will be asked to pay $${ammountToBePaid} and after that the books will be swapped. Do you wish to proceed?`
      );
    }
    setIsAlert(true);
  };
  const closeAlertModal = () => setIsAlert(false);
  const acceptAlert = () => {
    if (
      item?.offeringBook?.library?.price === item?.offeredBook?.library?.price
    ) {
      handleAccept();
    } else if (
      item?.offeringBook?.library?.price >= item?.offeredBook?.library?.price
    ) {
      handleAccept();
    } else if (
      item?.offeringBook?.library?.price <= item?.offeredBook?.library?.price
    ) {
      redirectOffer();
    }
  };
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const redirectOffer = async () => {
    let obj = {
      id: item?._id,
    };
    setLoader(true);
    await EditOffer(user?.token, obj)
      .then((res) => {
        if (res.statusText === "OK") {
          toastMessage(
            "Offer Accepted. Please wait for Other Party's Response",
            "success"
          );
          reload();
        } else {
          toastMessage(res.data, "error");
        }
        setLoader(false);
      })
      .catch((error) => {
        console.log(error.message);
        setLoader(false);
      });
  };
  const handleAccept = async () => {
    let web3 = await getWeb3(null);
    const accounts = await web3?.eth.getAccounts();
    const networkId = await web3?.eth.net.getId();
    const networkData = DigiBook.networks[networkId];
    setLoader(true);
    let obj = {
      book1: item?.offeredBook?._id,
      book2: item?.offeringBook?._id,
      offer: item?._id,
    };
    let ammountToBePaid = 0;

    await axios
      .get(
        "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=bitcoin%2Cethereum&order=market_cap_desc&per_page=100&page=1&sparkline=false"
      )
      .then(async (res) => {
        let price = 0;
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].name === "Ethereum") {
            price = res.data[i].current_price;
          }
        }
        ammountToBePaid =
          (parseInt(item?.offeringBook?.library?.price) -
            parseInt(item?.offeredBook?.library?.price)) /
          price;
        if (networkData) {
          const abi = DigiBook.abi;
          const address = networkData.address;
          const contract = new web3.eth.Contract(abi, address);
          try {
            const x = await contract.methods
              .swap(
                accounts[0],
                item?.offeringUser.walletaddress,
                item?.offeredToken,
                item?.offeringToken
              )
              .send({
                from: accounts[0],
                value: web3.utils.toWei(ammountToBePaid.toString(), "ether"),
              });
            await AcceptOffer(user?.token, obj)
              .then((res) => {
                if (res.statusText === "OK") {
                  setLoader(false);
                  let resp = {
                    ...user,
                  };
                  dispatch(setUser(resp));
                  toastMessage("Offer Accepted", "success");
                  reload();
                } else {
                  setLoader(false);
                  toastMessage(res.data, "error");
                }
              })
              .catch((error) => {
                console.log(error.message);
                setLoader(false);
              });
          } catch (err) {
            console.log(err);
            setLoader(false);
            toastMessage(err.message, "error");
          }
        } else {
          toastMessage("Smart Contract not deployed!", "error");
        }
      })
      .catch((error) => console.log(error));
  };
  const handleReject = async () => {
    setLoader2(true);
    await Reject(user?.token, item?._id)
      .then((res) => {
        if (res.statusText === "OK") {
          setLoader2(false);
          toastMessage("Offer Rejected", "success");
          reload();
        } else {
          setLoader2(false);
          toastMessage(res.data, "error");
        }
      })
      .catch((error) => {
        toastMessage(error.message, "error");
        setLoader2(false);
      });
  };
  return (
    <div
      data-aos="fade-up"
      data-aos-duration="500"
      className={`offer-card-top-container rounded ${
        item?.type === 1 && "mb-5 mt-5"
      }`}
    >
      <div className="offer-card-container">
        <div className="single-offer-card-container">
          <SingleBookDetailsCard item={item?.offeredBook} left isOffer />
        </div>
        <img
          src={require("../../../assets/icons/swap.svg").default}
          className="swap-img"
        />
        <div className="single-offer-card-container">
          <SingleBookDetailsCard item={item?.offeringBook} right isOffer />
        </div>
      </div>
      {item?.type === 1 && (
        <div className="d-flex flex-row justify-content-around pb-5">
          <div
            className="d-flex flex-row parent1"
            role="button"
            onClick={() => handleReject()}
          >
            {loader2 ? (
              <Spinner animation="grow" size="lg" />
            ) : (
              <>
                <div className="red-round">
                  <img
                    src={require("../../../assets/icons/deny.svg").default}
                    className="acpt-rjct-img red-icon-color "
                  />
                </div>
                <div className="d-flex align-items-center ml-2 red-text">
                  Deny
                </div>
              </>
            )}
          </div>
          <div
            className="d-flex flex-row parent2"
            role="button"
            onClick={() => openAlertModal()}
          >
            <>
              <div className="green-round">
                <img
                  src={require("../../../assets/icons/accept.svg").default}
                  className="acpt-rjct-img green-icon-color "
                />
              </div>
              <div className="d-flex align-items-center ml-2 green-text">
                Accept
              </div>
            </>
          </div>
        </div>
      )}
      <AlertModal
        openModal={isAlert}
        HideModal={closeAlertModal}
        msg={message}
        title={title}
        handleSubmit={acceptAlert}
        isSubmitting={loader}
      />
    </div>
  );
}

export default OfferCard;
